import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import "./DailyPageActivity.scss";
import { LoadTable } from "../../Components";
import "../Dashboard/Dashboard.scss";
import { processPageActivityTableData } from "../Dashboard/prepareChartData";
import Input from "../../Components/Input/Input";
import Button from "../../Components/Button/Button";
import { useSelector } from "react-redux";
import { GetAccountPageActivity } from "../../../Utils/AllPagesQuriesAndMutations";
import useProcessData from "../../../CommonFunction/ProcessData";

const DailyPageActivity = () => {
  const tableKey = "Activity_Table";
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const [Account, setAccount] = useState("");
  const [ActivityTableData, setActivityTableData] = useState([]);

  //chart
  const config = useMemo(
    () => ({
      dataKey: "getPageActivityForTableByAccount",
      dateKeysWithoutTime: ["date"],
      deleteKeys: ["__typename"],
    }),
    []
  );
  const [
    AccountActivity,
    {
      data: activityTable,

      error: activityError,

      networkStatus: activityNetworkRefetch,
    },
  ] = useLazyQuery(GetAccountPageActivity, {
    context: { headers: { "X-GraphQL-Server": "secondary" } },
  });

  const handleGo = () => {
    let Account_ID = FormDataFromRedux?.MasterData["Daily_Page_Activity"]?.Account_ID?._id;
    AccountActivity({ variables: { Account_ID } });
  };
  useProcessData(activityTable, setActivityTableData, config);
  return (
    <>
      <div className="AccountDrop">
        <Input
          EMTQuery=""
          checked={""}
          InputConfig={{
            masterName: "SearchAccountByProfileType",
            variable: {
              Profile_Type: "",
              Is_Mobile_Number_Verified: true,
            },
          }}
          type="InputDropForQuery"
          name="Account_ID"
          handleBlur={() => {}}
          handleInputChange={(e) => {
            setAccount(e.target.value);
          }}
          formkey={"Daily_Page_Activity"}
          label={"Account"}
          modalform={true}
          Iconinside={true}
          value={Account}
        />
        <Button name="gobutton" text="GO" action={handleGo}></Button>
      </div>
      <h3 class="load-Post-title">Page Activity Of Accounts</h3>
      <div className="Page_Activity_Of_Accounts_Box">
        <LoadTable
          data={ActivityTableData}
          // loading={activityLoading}
          error={activityError}
          title={tableKey}
          settings={false}
          options={false}
        />
      </div>
    </>
  );
};

export default DailyPageActivity;
